<template>
  <div class="container mt-3">
    <b-breadcrumb>
      <b-breadcrumb-item @click="chwd('/')">
        <b-icon icon="house-fill" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
      </b-breadcrumb-item>
      <b-breadcrumb-item v-for="e in navPathArr" @click="chwd(e.href)" :key="e.href">{{ e.path }}</b-breadcrumb-item>
    </b-breadcrumb>
    <div class="mt-3">
      <b-dropdown text="Options" variant="outline-primary">
        <b-dropdown-item v-b-modal.modal-touch>New File</b-dropdown-item>
        <b-dropdown-item @click="optBtnClick('mkdir')">New Folder</b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item @click="uploadBtnClick('upload-files')">Upload File</b-dropdown-item>
        <b-dropdown-item @click="uploadBtnClick('upload-folder')">Upload Folder</b-dropdown-item>
      </b-dropdown>

      <b-button @click="updateList()" class="ml-2">Sync</b-button>

      <b-button v-show="nextToken" @click="updateList(nowPath,nextToken)" class="ml-2">LoadNext</b-button>

      <b-button
        v-show="uploadData.uploadNow || uploadData.uploadQueue.length || uploadData.uploadSucess.length || uploadData.uploadFail.length"
        v-b-modal.modal-upload
        class="ml-2"
      >Upload Status</b-button>

      <b-button
        variant="primary"
        v-show="('mv' === cmdType) && srcPath"
        @click="optBtnClick('mv')"
        :title="srcPath"
        class="ml-2"
      >MoveTo</b-button>
      <b-button
        variant="primary"
        v-show="('cp' === cmdType) && srcPath"
        @click="optBtnClick('cp')"
        :title="srcPath"
        class="ml-2"
      >Paste</b-button>
      <b-button variant="primary" v-show="srcPath" @click="srcPath = ''" class="ml-2">Cancel</b-button>

      <span v-show="loadingbarData.show">
        <span class="mx-3">{{ loadingbarData.info }}</span>
        <b-spinner variant="primary" label="Spinning" class="float-right"></b-spinner>
      </span>
    </div>
    <b-table
      hover
      responsive
      id="list-table"
      :items="list"
      :fields="fields"
      :busy="loadingData.isBusy"
      primary-key="nameFormat"
      head-variant="light"
      class="border rounded mt-2"
      :per-page="pageData.perPage"
      :current-page="pageData.currentPage"
    >
      <template v-slot:cell(nameFormat)="data">
        <div class="opt-div">
          <b-icon
            icon="command"
            scale="1.25"
            shift-v="1.25"
            shift-h="-3"
            aria-hidden="true"
            class="opt-icon"
          ></b-icon>
          <div class="opt-btns">
            <b-button-group vertical>
              <b-button @click="optBtnClick('rm',data.item.name)">Delete</b-button>
              <b-button @click="optBtnClick('ren',data.item.name)">Rename</b-button>
              <b-button @click="optBtnClick('mv_',data.item.name)">Move</b-button>
              <b-button @click="optBtnClick('cp_',data.item.name)">Copy</b-button>
              <b-button v-if="!data.item.type" @click="downloadNow(data.item.name)">Download</b-button>
            </b-button-group>
          </div>
        </div>
        <a v-if="data.item.type" href="#" @click="chwd(data.item.name + '/')">{{ data.item.name }}/</a>
        <span v-else>{{ data.item.name }}</span>
      </template>

      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>{{ loadingData.info }}</strong>
        </div>
      </template>
    </b-table>
    <div class="overflow-auto" style="display: flex;justify-content: flex-end;">
      <b-pagination
        v-model="pageData.currentPage"
        :total-rows="list.length"
        :per-page="pageData.perPage"
        aria-controls="list-table"
      ></b-pagination>
      <b-form-select
        v-model="pageData.perPage"
        :options="pageData.pageOptions"
        class="mb-3 ml-2"
        style="width: 100px;"
      ></b-form-select>
    </div>

    <div class="fixed-bottom">
      <b-alert
        :show="alertData.dismissCountDown"
        dismissible
        fade
        :variant="alertData.type"
        @dismiss-count-down="countDownChanged"
      >{{ alertData.info }}</b-alert>
    </div>

    <b-modal id="modal-touch" size="lg" title="touch a new file" @ok="optBtnClick('touch')">
      <form ref="form-touch" @submit.stop.prevent>
        <b-form-group label="file name:">
          <b-form-input v-model="uploadData.uploadTouch.name"></b-form-input>
        </b-form-group>
        <b-form-group label="file content:">
          <b-form-textarea
            v-model="uploadData.uploadTouch.content"
            placeholder="here is the file content"
            rows="8"
            max-rows="16"
          ></b-form-textarea>
        </b-form-group>
      </form>
    </b-modal>

    <b-modal id="modal-upload" size="lg" title="upload status" scrollable hide-footer hide-header>
      <div class="container">
        <div v-if="uploadData.uploadNow">
          <p class="text-primary">now</p>
          {{uploadData.uploadNow.file.name }}
          <b-progress
            :value="uploadData.uploadSize"
            :max="uploadData.uploadNow.file.size"
            show-progress
            animated
          ></b-progress>
        </div>
        <p class="text-secondary">waiting:{{uploadData.uploadQueue.length}}</p>
        <p v-for="e in uploadData.uploadQueue" :key="e.path+e.file.name">
          {{e.file.name }} -- {{ common.formatSize(e.file.size) }} --
          {{ e.path }}
        </p>
        <p class="text-danger">fail:{{uploadData.uploadFail.length}}</p>
        <p v-for="e in uploadData.uploadFail" :key="e.path+e.file.name">
          <a href="#" @click.prevent="retryUpload(e)">
            <b-icon-arrow-clockwise></b-icon-arrow-clockwise>
          </a>
          {{e.file.name }} -- {{ common.formatSize(e.file.size) }} --
          {{ e.path }}
        </p>
        <p class="text-success">success:{{uploadData.uploadSucess.length}}</p>
        <p v-for="e in uploadData.uploadSucess" :key="e.path+e.file.name">
          {{e.file.name }} -- {{ common.formatSize(e.file.size) }} --
          {{ e.path }}
        </p>
      </div>
    </b-modal>

    <input type="file" ref="upload-files" multiple @change="uploadOnChange" class="d-none" />
    <input type="file" ref="upload-folder" webkitdirectory @change="uploadOnChange" class="d-none" />
  </div>
</template>
<script>
export default {
  data() {
    return {
      nowPath: "/",
      list: [],
      nextToken: "",
      listCache: {},
      pageData: {
        currentPage: 1,
        perPage: 10,
        pageOptions: [
          {
            text: "10/Page",
            value: 10
          },
          {
            text: "50/Page",
            value: 50
          }
        ]
      },
      srcPath: "",
      cmdType: "",

      uploadData: {
        uploadQueue: [],
        uploadSucess: [],
        uploadFail: [],
        uploadNow: null,
        uploadSize: 0,
        uploadTouch: {
          name: "",
          content: ""
        }
      },

      searchData: {
        text: "",
        parentPath: "",
        content: []
      },
      loadingbarData: {
        show: false,
        info: "default info"
      },
      loadingData: {
        isBusy: false,
        info: "default info"
      },
      alertData: {
        dismissCountDown: 0,
        type: "primary",
        info: "default info"
      },
      fields: [
        {
          key: "nameFormat",
          label: "Name"
        },
        {
          key: "time",
          label: "Time",
          thStyle: "width:180px",
          class: "d-none d-md-table-cell",
          formatter: this.common.formatDate
        },
        {
          key: "size",
          label: "Size",
          thStyle: "width:120px",
          class: "text-right mr-3 d-none d-md-table-cell",
          formatter: this.common.formatSize
        }
      ]
    };
  },
  created: function() {
    this.updateList();
  },
  methods: {
    chwd(path) {
      if (path.startsWith("/")) this.updateList(path);
      else this.updateList(this.nowPath + path);
    },
    loadNextContent(page) {
      console.log(page);
    },
    updateList(path, spPage) {
      let flag;
      let _this = this;
      if (!path) {
        path = this.nowPath;
        flag = true;
      }
      if (this.listCache[path] && !flag && !spPage) {
        this.list = this.listCache[path].list;
        this.nextToken = this.listCache[path].nextToken;
        this.nowPath = path;
        return;
      }
      if (this.loadingData.isBusy)
        return this.showAlert("Processing other tasks, try again later", "w");
      this.loadingData.isBusy = true;
      this.loadingData.info = "loading... " + path;
      console.log("try: ls " + path + (spPage ? "?spPage=" + spPage : ""));
      this.common.axios
        .post("./api/cmd", {
          cmdType: "ls",
          cmdData: {
            path: path,
            spPage: spPage
          }
        })
        .then(r => {
          _this.loadingData.isBusy = false;
          console.log(r.data);
          if (r.data.list) {
            _this.nowPath = path;
            if (!spPage) _this.listCache[path] = r.data;
            else {
              r.data.list.forEach(e => _this.listCache[path].list.push(e));
              _this.listCache[path].nextToken = r.data.nextToken;
            }
            _this.list = _this.listCache[path].list;
            _this.nextToken = r.data.nextToken;
          } else console.log(r.data);
        })
        .catch(e => {
          _this.loadingData.isBusy = false;
          console.log(e);
          if (e.response !== undefined) {
            if (e.response.status === 401)
              _this.$router.push({ path: "/login" });
            else _this.showAlert("error: " + e.response.data.info, "d");
          } else _this.showAlert("error: " + e.message, "d");
        });
    },
    sendCmd(cmdType, cmdData) {
      let _this = this;
      let cmdstr = cmdToStr();
      console.log("try: " + cmdstr);
      this.loadingbarData.info = cmdstr;
      this.loadingbarData.show = true;
      this.common.axios
        .post("./api/cmd", {
          cmdType,
          cmdData
        })
        .then(res => {
          this.loadingbarData.show = false;
          let pn, pos, r, url;
          switch (cmdType) {
            case "mkdir":
              _this.listCache[cmdData.path].list.unshift({
                type: 1,
                name: cmdData.name,
                size: 0,
                mime: "",
                time: _this.common.formatDate(new Date())
              });
              return;
            case "mv":
            case "cp":
              pn = splitPathAName(cmdData.srcPath);
              pos = -1;
              r = _this.listCache[pn.path].list.find((e, i) => {
                pos = i;
                return e.name === pn.name;
              });
              if (cmdType === "mv")
                _this.listCache[pn.path].list.splice(pos, 1);
              _this.listCache[cmdData.desPath].list.unshift(r);
              return;
            case "rm":
            case "ren":
              pn = splitPathAName(cmdData.path);
              pos = -1;
              r = _this.listCache[pn.path].list.find((e, i) => {
                pos = i;
                return e.name === pn.name;
              });
              if (cmdType === "rm")
                _this.listCache[pn.path].list.splice(pos, 1);
              else r.name = cmdData.name;
              return;
            case "touch":
              _this.listCache[cmdData.path].list.unshift({
                type: 0,
                name: cmdData.name,
                size: _this.common.formatSize(cmdData.content.length),
                mime: "onepoint/unknown",
                time: _this.common.formatDate(new Date())
              });
              return;
            case "upload":
              url = res.data.uploadUrl;
              _this.common.axios
                .get(url, { withCredentials: false })
                .then(r => {
                  _this.fileUpload(r.data, url);
                });
              return;
            case "find":
              _this.nowPath = res.data.parentPath;
              _this.content = res.data.data.content;
              return;
            default:
              console.log("unknown: " + cmdType);
              return;
          }
        })
        .catch(e => {
          _this.loadingbarData.show = false;
          console.log(e);
          if (e.response !== undefined) {
            _this.showAlert("error: " + e.response.data.info, "d");
          } else _this.showAlert("error: " + e.message, "d");
          if (cmdType === "upload" && _this.uploadData.uploadNow) {
            _this.uploadData.uploadFail.unshift(_this.uploadData.uploadNow);
            _this.uploadData.uploadNow = null;
          }
        });

      function cmdToStr() {
        switch (cmdType) {
          case "mkdir":
            return "mkdir " + cmdData.path + cmdData.name;
          case "mv":
          case "cp":
            return cmdType + " " + cmdData.srcPath + " " + cmdData.desPath;
          case "rm":
            return "rm " + cmdData.path;
          case "ren":
            return "ren " + cmdData.path + " " + cmdData.name;
          case "touch":
          case "upload":
            return cmdType + " " + cmdData.path + (cmdData.name || "");
          case "find":
            return cmdType + " " + cmdData.path + " " + cmdData.text;
          default:
            return "unknown: " + cmdType;
        }
      }

      function splitPathAName(path = "") {
        if (path.endsWith("/")) path = path.slice(0, -1);
        let pos = path.lastIndexOf("/") + 1;
        return {
          path: path.slice(0, pos),
          name: path.slice(pos)
        };
      }
    },
    optBtnClick(cmd, fileName = "") {
      let tPath = this.nowPath + fileName;
      let _this = this;
      let upInfo;
      switch (cmd) {
        //新建文件夹 上传文本小文件 大文件
        case "mkdir":
          this.$prompt({
            title: "mkdir",
            message: "make dir in: " + tPath,
            ok: value => {
              _this.sendCmd(cmd, {
                path: tPath,
                name: value
              });
            }
          });
          return;
        case "mv_":
          this.cmdType = "mv";
          this.srcPath = tPath;
          return;
        case "mv":
          if (
            !this.srcPath ||
            this.srcPath.slice(0, this.srcPath.lastIndexOf("/") + 1) ===
              this.nowPath
          )
            return;
          this.$confirm({
            title: "mv",
            message: "move :" + this.srcPath + " -> " + this.nowPath,
            ok: () => {
              _this.sendCmd(cmd, {
                srcPath: this.srcPath,
                desPath: this.nowPath
              });
              _this.srcPath = "";
            }
          });
          return;
        case "cp_":
          this.cmdType = "cp";
          this.srcPath = tPath;
          return;
        case "cp":
          if (
            !this.srcPath ||
            this.srcPath.slice(0, this.srcPath.lastIndexOf("/") + 1) ===
              this.nowPath
          )
            return;
          this.$confirm({
            title: "cp",
            message: "copy :" + this.srcPath + " -> " + this.nowPath,
            ok: () => {
              _this.sendCmd(cmd, {
                srcPath: this.srcPath,
                desPath: this.nowPath
              });
              _this.srcPath = "";
            }
          });
          return;
        case "rm":
          this.$confirm({
            title: "rm",
            message: "remove: " + tPath,
            ok: () => {
              _this.sendCmd(cmd, {
                path: tPath
              });
            }
          });
          return;
        case "ren":
          this.$prompt({
            title: "ren",
            message: "rename: " + tPath,
            ok: value => {
              _this.sendCmd(cmd, {
                path: tPath,
                name: value
              });
            }
          });
          return;
        case "touch":
          if (!this.uploadData.uploadTouch.name) return;
          this.sendCmd(cmd, {
            path: this.nowPath,
            name: this.uploadData.uploadTouch.name,
            content: this.uploadData.uploadTouch.content || ""
          });
          this.uploadData.uploadTouch.name = "";
          this.uploadData.uploadTouch.content = "";
          return;
        case "upload":
          if (
            this.uploadData.uploadNow ||
            this.uploadData.uploadQueue.length === 0
          )
            return;
          this.uploadData.uploadNow = this.uploadData.uploadQueue.shift();
          upInfo = this.uploadData.uploadNow;
          this.sendCmd(cmd, {
            path: upInfo.path + upInfo.file.name,
            fileSystemInfo: {
              lastModifiedDateTime: upInfo.file.lastModifiedDate.toISOString()
            }
          });
          return;
        case "find":
          this.sendCmd(cmd, {
            path: this.nowPath,
            text: this.searchData.text
          });
          return;
        default:
          console.log("err: " + cmd);
          return;
      }
    },

    showAlert(info, type) {
      this.alertData.dismissCountDown = 5;
      this.alertData.type =
        {
          i: "info",
          d: "danger",
          s: "success",
          w: "warning"
        }[type] || "primary";
      this.alertData.info = info;
    },
    countDownChanged(dismissCountDown) {
      this.alertData.dismissCountDown = dismissCountDown;
    },

    uploadBtnClick(ref) {
      this.$refs[ref].click();
    },
    uploadOnChange(event) {
      console.log(event.target.files);
      let files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        this.uploadData.uploadQueue.push({
          path: this.nowPath,
          file: files[i],
          time: new Date()
        });
      }
    },
    fileUpload(res, url) {
      let offset, offset1, uploadUrl, file;
      let _this = this;
      file = this.uploadData.uploadNow.file;
      let s2 = res.nextExpectedRanges[0].split("-");
      offset = Number(s2[0]);
      offset1 = s2[1] ? Number(s2[1]) + 1 : file.size;
      uploadUrl = url || res.uploadUrl;
      if (offset1 > offset + 10485760) offset1 = offset + 10485760;
      let reader = new FileReader();
      reader.readAsArrayBuffer(file.slice(offset, offset1));
      reader.onload = function(event) {
        console.log("send: [" + offset + "," + offset1 + ")");
        _this.common.axios
          .put(uploadUrl, event.target.result, {
            headers: {
              //'Content-Length': offset1 - offset,
              "Content-Range": `bytes ${offset}-${offset1 - 1}/${file.size}`
            },
            onUploadProgress: progressEvent => {
              let loaded = progressEvent.loaded;
              _this.uploadData.uploadSize = offset + loaded;
            },
            withCredentials: false
          })
          .then(r => {
            console.log(r.data);
            console.log("success: [" + offset + "," + offset1 + ")");
            if (r.status === 201) {
              _this.listCache[_this.uploadData.uploadNow.path].list.unshift({
                type: 0,
                name: _this.uploadData.uploadNow.file.name,
                size: _this.common.formatSize(
                  _this.uploadData.uploadNow.file.size
                ),
                mime: "onepoint/unknown",
                time: _this.common.formatDate(
                  _this.uploadData.uploadNow.file.lastModifiedDate
                )
              });
              _this.showAlert(
                "success: upload" + _this.uploadData.uploadNow.file.name,
                "i"
              );
              console.log("success: " + JSON.stringify(res));
              _this.uploadData.uploadSucess.push(_this.uploadData.uploadNow);
              _this.uploadData.uploadNow = null;
              return;
            } else if (r.status === 202) {
              _this.fileUpload(r.data, uploadUrl);
            } else throw r;
          })
          .catch(err => {
            console.log(err);
            _this.showAlert("error: " + err.message, "d");
            if (_this.uploadData.uploadNow) {
              console.error("fail: upload " + file.name);
              _this.uploadData.uploadFail.unshift(_this.uploadData.uploadNow);
              _this.uploadData.uploadNow = null;
            }
          });
      };
    },
    retryUpload(obj) {
      console.log(obj);
      this.uploadData.uploadFail = this.uploadData.uploadFail.filter(e => {
        return e !== obj;
      });
      this.uploadData.uploadQueue.push(obj);
    },
    downloadNow(name) {
      window.open(this.common.completeUrl(this.nowPath + name), "_blank");
    }
  },
  computed: {
    navPathArr: function() {
      let path = this.nowPath;
      let tmpPath = "/";
      let arr = [];
      path.split("/").forEach(e => {
        if (!e) return;
        tmpPath += e;
        tmpPath += "/";
        arr.push({
          path: e,
          href: tmpPath
        });
      });
      return arr;
    }
  },
  beforeUpdate() {
    if (!this.uploadData.uploadNow) {
      this.optBtnClick("upload");
    }
  }
};
</script>
<style>
.opt-btns {
  display: none;
  position: absolute;
}

.opt-div {
  display: inline-block;
}

.opt-icon {
  cursor: pointer;
}

.opt-div:hover .opt-btns {
  display: block;
}
</style>